// authUser
export const CHANGE_AUTH_USER = 'CHANGE_AUTH_USER'
export const SET_AUTH_USER_USERNAME = 'SET_AUTH_USER_USERNAME'
// comments
export const ADD_COMMENTS = 'ADD_COMMENTS'
export const SET_COMMENTS_OVER = 'SET_COMMENTS_OVER'
export const CREATE_COMMENT = 'CREATE_COMMENT'
export const SET_COMMENT_LIKES = 'SET_COMMENT_LIKES'
export const SET_IS_COMMENT_LIKED = 'SET_IS_COMMENT_LIKED'
// responses
export const ADD_RESPONSES = 'ADD_RESPONSES'
export const SET_RESPONSES_OVER = 'SET_RESPONSES_OVER'
export const CREATE_RESPONSE = 'CREATE_RESPONSE'
export const SET_RESPONSE_LIKES = 'SET_RESPONS_LIKES'
export const SET_IS_RESPONSE_LIKED = 'SET_IS_RESPONS_LIKED'